import React from 'react'
import styled from 'styled-components'
import HeroNYC from "~/public/static/images/webp/hero-nyc.webp"

const Container = styled.div`
  min-height: 300px;
  background-image: url(${HeroNYC});
  background-color: ${props => props.theme.colors.text.header};
  background-position: 50% 100%;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 4rem;
`

const MainText = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  text-shadow: 1px 1px 3px black;
  font-size: 1.9rem;
  color: white;
  margin-bottom: 2rem;
  text-align: center;
`

const SubText = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  color: white;
  text-shadow: 1px 1px 3px black;
  opacity: 0.9;
  font-size: 1.3rem;
  text-align: center;
`

const Hero = () => {
  return (
    <Container>
      <MainText>Help thousands of drivers every day.</MainText>
      <SubText>
        Join the team behind New York City's #1 app for fighting parking and
        traffic tickets.
      </SubText>
    </Container>
  )
}

export default Hero
